/* UltimateKicks — interaction layer
   - My size: remembered across visits, auto-selected on product pages
   - Saved pairs: heart on every product card, shared with The Wall
   - Hologram tilt on product cards (mouse only)
   - Small toast for feedback */
(function () {
  if (window.ukFxLoaded) return;
  window.ukFxLoaded = true;

  var SIZE_KEY = 'uk-size';
  var SAVED_KEY = 'uk-saved';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Shared store ---------- */
  function read(key, fallback) {
    try {
      var v = localStorage.getItem(key);
      return v === null ? fallback : JSON.parse(v);
    } catch (e) { return fallback; }
  }
  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }
  var store = {
    getSize: function () { return read(SIZE_KEY, ''); },
    setSize: function (size) {
      write(SIZE_KEY, size || '');
      document.dispatchEvent(new CustomEvent('uk:size', { detail: size || '' }));
    },
    getSaved: function () { return read(SAVED_KEY, []); },
    isSaved: function (handle) { return store.getSaved().indexOf(handle) !== -1; },
    toggleSaved: function (handle) {
      var list = store.getSaved();
      var i = list.indexOf(handle);
      if (i === -1) list.push(handle); else list.splice(i, 1);
      write(SAVED_KEY, list);
      document.dispatchEvent(new CustomEvent('uk:saved', { detail: list }));
      return i === -1;
    }
  };
  window.ukStore = store;

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(message, linkText, href) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'uk-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    toastEl.appendChild(span);
    if (linkText && href) {
      var a = document.createElement('a');
      a.href = href;
      a.textContent = linkText;
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }
  window.ukToast = toast;

  /* ---------- Hearts on product cards ---------- */
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3 4.6 13.1a4.9 4.9 0 0 1 6.9-7l.5.5.5-.5a4.9 4.9 0 0 1 6.9 7Z"/></svg>';

  function handleFromUrl(url) {
    var m = (url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function paintHeart(btn, saved) {
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', saved ? 'Quitar de guardados' : 'Guardar este par');
  }

  function decorateCard(card) {
    if (card.dataset.ukDecorated === '1') return;
    var link = card.querySelector('a[href*="/products/"]');
    var gallery = card.querySelector('.card-gallery');
    if (!link || !gallery) return;
    var handle = handleFromUrl(link.getAttribute('href'));
    if (!handle) return;
    card.dataset.ukDecorated = '1';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'uk-heart';
    btn.dataset.handle = handle;
    btn.innerHTML = HEART;
    paintHeart(btn, store.isSaved(handle));
    gallery.appendChild(btn);

    /* Boutique: sin inclinación ni brillo en las tarjetas */
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.uk-heart');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var nowSaved = store.toggleSaved(btn.dataset.handle);
    paintHeart(btn, nowSaved);
    if (nowSaved) toast('Guardado en tu estantería', 'Verlo en The Wall', '/pages/the-wall');
    else toast('Quitado de tu estantería');
  }, true);

  document.addEventListener('uk:saved', function (e) {
    var list = e.detail || [];
    Array.prototype.forEach.call(document.querySelectorAll('.uk-heart'), function (btn) {
      paintHeart(btn, list.indexOf(btn.dataset.handle) !== -1);
    });
  });

  /* ---------- Hologram tilt ---------- */
  function attachTilt(el) {
    el.classList.add('uk-holo');
    var frame = null;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      var y = (e.clientY - r.top) / r.height;
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        el.style.setProperty('--ry', ((x - 0.5) * 12).toFixed(2) + 'deg');
        el.style.setProperty('--rx', ((0.5 - y) * 12).toFixed(2) + 'deg');
        el.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        el.classList.add('is-tilting');
      });
    });
    el.addEventListener('pointerleave', function () {
      if (frame) cancelAnimationFrame(frame);
      el.classList.remove('is-tilting');
      el.style.setProperty('--rx', '0deg');
      el.style.setProperty('--ry', '0deg');
    });
  }

  function scanCards(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('product-card, .product-card'), decorateCard);
  }

  /* ---------- Product page: my size ---------- */
  function isSneakerPage() {
    return document.body && (document.body.dataset.productType === 'Sneakers' || document.body.dataset.productType === 'Botas de fútbol');
  }

  function preselectSize() {
    var size = store.getSize();
    if (!size || !isSneakerPage()) return;
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    var inputs = picker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var value = (input.value || '').replace(/^[A-Za-z]+\s*/, '').trim();
      if (value === size) {
        if (!input.checked && input.getAttribute('data-option-available') !== 'false') {
          var label = input.closest('label');
          (label || input).click();
          toast('Tu talla ' + size + ' está seleccionada');
        }
        return;
      }
    }
  }

  /* ---------- Product page data ---------- */
  var productData = null;
  function getProductData() {
    if (productData !== null) return productData;
    var el = document.getElementById('uk-product-data');
    try { productData = el ? JSON.parse(el.textContent) : false; } catch (e) { productData = false; }
    return productData;
  }
  function cleanSize(v) { return (v || '').replace(/^[A-Za-z]+\s*/, '').trim(); }
  function lowestVariant(d) {
    var best = null;
    d.variants.forEach(function (v) {
      if (!v.available) return;
      if (!best || v.cents < best.cents) best = v;
    });
    return best;
  }
  function distinctPrices(d) {
    var seen = {};
    d.variants.forEach(function (v) { if (v.available) seen[v.cents] = true; });
    return Object.keys(seen).length;
  }
  // Style code = SKU without any size suffix ("CT8527-016-EU35.5" -> "CT8527-016").
  function styleCode(d) {
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i];
      if (!v.sku) continue;
      var parts = String(v.sku).trim().split('-');
      if (parts.length > 1) {
        var last = parts[parts.length - 1].replace(/^(EU|US|UK)\s*/i, '').replace(/\s+/g, '');
        var size = String(v.size || '').replace(/\s+/g, '');
        var looksLikeSize = /^\d{1,2}([.,]\d)?(\d\/3)?$/.test(last);
        if (last === size || (parts.length >= 3 && looksLikeSize)) parts.pop();
      }
      return parts.join('-');
    }
    return '';
  }

  // Latest delivery date: today + 15 business days.
  function deliveryDate() {
    var d = new Date();
    var added = 0;
    while (added < 15) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  /* Shoebox label under the price */
  function buildPdpLabel(d) {
    var rows = [['Marca', d.vendor]];
    var code = styleCode(d);
    if (code) rows.push(['Código de estilo', code]);
    var low = lowestVariant(d);
    if (low && distinctPrices(d) > 1) {
      rows.push(['Precio más bajo', low.price + ((d.type === 'Sneakers' || d.type === 'Botas de fútbol') ? ' en EU ' : ' en talla ') + low.size, 'is-lowest']);
    }
    rows.push(['Entrega como tarde', deliveryDate()]);

    var box = document.createElement('div');
    box.className = 'uk-pdp-label';
    box.setAttribute('data-uk-pdp-label', '');
    var dl = document.createElement('dl');
    rows.forEach(function (r) {
      var row = document.createElement('div');
      if (r[2]) row.className = r[2];
      var dt = document.createElement('dt'); dt.textContent = r[0];
      var dd = document.createElement('dd');
      if (r[0] === 'Código de estilo') {
        var copy = document.createElement('button');
        copy.type = 'button';
        copy.className = 'uk-copy';
        copy.textContent = r[1];
        copy.setAttribute('aria-label', 'Copiar código de estilo ' + r[1]);
        copy.addEventListener('click', function () {
          var done = function () { toast('Código de estilo copiado'); };
          if (navigator.clipboard) navigator.clipboard.writeText(r[1]).then(done, done); else done();
        });
        dd.appendChild(copy);
      } else {
        dd.textContent = r[1];
      }
      row.appendChild(dt); row.appendChild(dd); dl.appendChild(row);
    });
    box.appendChild(dl);
    return box;
  }

  /* Price under every size, cheapest highlighted */
  function decorateSizes(d, picker) {
    if (distinctPrices(d) < 2) return;
    var map = {};
    d.variants.forEach(function (v) { map[v.size] = v; });
    var low = lowestVariant(d);
    Array.prototype.forEach.call(picker.querySelectorAll('.variant-option__button-label'), function (label) {
      if (label.querySelector('.uk-size-price')) return;
      var input = label.querySelector('input');
      var v = input && map[cleanSize(input.value)];
      if (!v || !v.available) return;
      var span = document.createElement('span');
      span.className = 'uk-size-price';
      span.textContent = v.price;
      label.appendChild(span);
      label.classList.add('uk-priced');
      if (low && v.size === low.size) label.classList.add('is-lowest');
    });
  }

  function decoratePdp() {
    var d = getProductData();
    if (!d) return;
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    if (!document.querySelector('[data-uk-pdp-label]')) {
      picker.parentNode.insertBefore(buildPdpLabel(d), picker);
    }
    decorateSizes(d, picker);
  }

  /* Add to cart: the pair flies into the bag, and a sneaker size is remembered */
  function flyToCart() {
    if (reduceMotion || !Element.prototype.animate) return;
    var src = document.querySelector('media-gallery img, .product-media img, .product-information img');
    var cart = document.querySelector('#header-component a[href*="/cart"], header a[href*="/cart"], .header-actions__cart-icon');
    if (!src || !cart) return;
    var a = src.getBoundingClientRect();
    var b = cart.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var size = 120;
    var ghost = document.createElement('div');
    ghost.className = 'uk-fly';
    var img = document.createElement('img');
    img.src = src.currentSrc || src.src;
    img.alt = '';
    ghost.appendChild(img);
    ghost.style.left = (a.left + a.width / 2 - size / 2) + 'px';
    ghost.style.top = (a.top + a.height / 2 - size / 2) + 'px';
    document.body.appendChild(ghost);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    var anim = ghost.animate([
      { transform: 'translate(0, 0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px, ' + (dy * 0.5 - 90) + 'px) scale(.7) rotate(-8deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(.15) rotate(-14deg)', opacity: 0.2 }
    ], { duration: 780, easing: 'cubic-bezier(.5,0,.3,1)' });
    anim.onfinish = function () {
      ghost.remove();
      cart.classList.add('uk-cart-bump');
      setTimeout(function () { cart.classList.remove('uk-cart-bump'); }, 460);
    };
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('button[name="add"], .add-to-cart-button');
    if (!addBtn || addBtn.closest('.quick-add') || addBtn.disabled || !getProductData()) return;
    flyToCart();
    if (!isSneakerPage()) return;
    var checked = document.querySelector('variant-picker input[type="radio"]:checked');
    if (!checked) return;
    var value = cleanSize(checked.value);
    if (value && value !== store.getSize()) store.setSize(value);
  });

  /* ---------- Intro: tap to skip ---------- */
  function bootIntro() {
    var intro = document.querySelector('.uk-intro');
    if (!intro) return;
    function done() { intro.classList.add('is-done'); }
    intro.addEventListener('click', done);
    setTimeout(done, 2200);
  }

  /* ---------- Boot ---------- */
  function boot() {
    bootIntro();
    scanCards(document);
    decoratePdp();
    preselectSize();

    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; scanCards(document); decoratePdp(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
